export default __webpack_public_path__ + "static/media/photo5.d996ea35.jpg";